module.exports = __webpack_public_path__ + "media/images/ceremony/ceremony-wedding-recommended-image-c405e4a9bc9d0a32f8cfc9f1294605dc.png";